var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('my-header'),_c('header-body'),(!['/', '/login'].includes(_vm.$route.path))?_c('bread'):_vm._e(),_c('div',{staticClass:"main-content",style:(_vm.contentStyle)},[(_vm.isCreatePage11)?_c('div',[(_vm.isShow)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1):_vm._e()]),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }